<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Purchase Order</h4>
                        <h6 class="card-subtitle">Please keep your profile information always current in order to help
                            you when you contact us.</h6>
                    </div>
                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="card-body card-blue">
                            <div class="form-group row">
                                <label class="text-right col-sm-2">Select Partner Type</label>
                                <div class="col-sm-8">
                                    <div class="form-check form-check-inline">
                                        <input :class="{'is-invalid': submitted && errors.has('type')}"
                                               class="form-check-input"
                                               data-vv-as="type"
                                               id="Member"
                                               name="type"
                                               type="radio"
                                               v-model="partner_type"
                                               v-validate="'required'"
                                               value="Member">
                                        <label class="form-check-label" for="Member">Member</label>
                                    </div>
                                    <div class="form-check form-check-inline">
                                        <input :class="{'is-invalid': submitted && errors.has('type')}"
                                               class="form-check-input"
                                               data-vv-as="type"
                                               id="Supplier"
                                               name="type"
                                               type="radio"
                                               v-model="partner_type"
                                               v-validate="'required'"
                                               value="Supplier">
                                        <label class="form-check-label" for="Supplier">Supplier</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row" v-if="partner_type === 'Supplier'">
                                <label class="col-sm-2 text-right control-label col-form-label" for="supplier_id">Supplier</label>
                                <div class="col-sm-8">
                                    <multiselect :class="{'is-invalid': submitted && errors.has('supplier_id')}"
                                                 :options="suppliers"
                                                 @input="setAddress(po.supplier)"
                                                 @search-change="searchSuppliers"
                                                 class="form-control"
                                                 data-vv-as="Supplier"
                                                 id="supplier_id"
                                                 label="org_name"
                                                 name="supplier_id"
                                                 open-direction="bottom"
                                                 placeholder="Select Supplier"
                                                 v-model="po.supplier"
                                                 v-validate="'required'">
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('supplier_id')">{{
                                        errors.first('supplier_id') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row" v-if="partner_type === 'Member'">
                                <label class="col-sm-2 text-right control-label col-form-label"
                                       for="member_id">Member</label>
                                <div class="col-sm-8">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('member_id')}"
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="true"
                                            :limit="3"
                                            :max-height="600"
                                            :options="members"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @search-change="searchMembers"
                                            class="form-control"
                                            data-vv-as="buyer"
                                            id="did"
                                            label="short_name"
                                            name="member_id"
                                            open-direction="bottom"
                                            placeholder="Search Member"
                                            track-by="did"
                                            v-model="po.member">
                                        <template slot="singleLabel" slot-scope="props">
                                            {{props.option.short_name}}
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <h5>{{ props.option.short_name }}</h5>
                                                <div>{{ props.option.did | did }}</div>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('member_id')">{{
                                        errors.first('member_id') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row" v-if="partner_type">
                                <label class="col-sm-2 text-right control-label col-form-label">Address:</label>
                                <div class="col-sm-4">
                                    <input :class="{'is-invalid': submitted && errors.has('email')}"
                                           class="form-control"
                                           data-vv-as="Email"
                                           id="email"
                                           name="email"
                                           placeholder="Email"
                                           type="email"
                                           v-model="po.supplier_address.email"
                                           v-validate="'email'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('email')">{{
                                        errors.first('email') }}
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <input :class="{'is-invalid': submitted && errors.has('phone')}"
                                           class="form-control"
                                           data-vv-as="Phone"
                                           id="phone"
                                           name="phone"
                                           placeholder="Phone"
                                           type="text"
                                           v-model="po.supplier_address.phone"
                                           v-validate="''">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('phone')">{{
                                        errors.first('phone') }}
                                    </div>
                                </div>
                                <div class="col-sm-4 offset-2 mt-3">
                                    <input :class="{'is-invalid': submitted && errors.has('line1')}"
                                           class="form-control"
                                           data-vv-as="Line 1"
                                           id="line1"
                                           name="line1"
                                           placeholder="Line 1"
                                           type="text"
                                           v-model="po.supplier_address.line1"
                                           v-validate="''">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('line1')">{{
                                        errors.first('line1') }}
                                    </div>
                                </div>
                                <div class="col-sm-4 mt-3">
                                    <input :class="{'is-invalid': submitted && errors.has('line2')}"
                                           class="form-control"
                                           data-vv-as="Line 2"
                                           id="line2"
                                           name="line2"
                                           placeholder="Line 2"
                                           type="text"
                                           v-model="po.supplier_address.line2"
                                           v-validate="">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('line2')">{{
                                        errors.first('line2') }}
                                    </div>
                                </div>
                                <div class="col-sm-4 offset-2 mt-3">
                                    <input :class="{'is-invalid': submitted && errors.has('city')}"
                                           class="form-control"
                                           data-vv-as="City"
                                           id="city"
                                           name="city"
                                           placeholder="City"
                                           type="text"
                                           v-model="po.supplier_address.city"
                                           v-validate="''">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('city')">{{
                                        errors.first('city') }}
                                    </div>
                                </div>
                                <div class="col-sm-4 mt-3">
                                    <input :class="{'is-invalid': submitted && errors.has('state')}"
                                           class="form-control"
                                           data-vv-as="state"
                                           id="state"
                                           name="state"
                                           placeholder="State"
                                           type="text"
                                           v-model="po.supplier_address.state"
                                           v-validate="''">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('state')">{{
                                        errors.first('state') }}
                                    </div>
                                </div>
                                <div class="col-sm-4 offset-2 mt-3">
                                    <input :class="{'is-invalid': submitted && errors.has('zip')}"
                                           class="form-control"
                                           data-vv-as="zip"
                                           id="zip"
                                           name="zip"
                                           placeholder="Zip"
                                           type="text"
                                           v-model="po.supplier_address.zip"
                                           v-validate="''">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('zip')">{{
                                        errors.first('zip') }}
                                    </div>
                                </div>
                                <div class="col-sm-4 mt-3">
                                    <input :class="{'is-invalid': submitted && errors.has('country')}"
                                           class="form-control"
                                           data-vv-as="country"
                                           id="country"
                                           name="country"
                                           placeholder="Country"
                                           type="text"
                                           v-model="po.supplier_address.country"
                                           v-validate="''">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('country')">{{
                                        errors.first('country') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="contract">Select
                                    Contract</label>
                                <div class="col-sm-4">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('contract')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="contracts"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @input="setContract()"
                                            @search-change="searchContracts"
                                            class="form-control"
                                            data-vv-as="contract"
                                            id="contract"
                                            label="contract"
                                            name="contract"
                                            open-direction="bottom"
                                            placeholder="Search Contract"
                                            track-by="id"
                                            v-model="contract"
                                            v-validate="">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.contract_number }} - {{props.option.type}} - {{
                                                    props.option.counterparty.name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.contract_number }}</h5>
                                                    <h5>{{ props.option.type }}</h5>
                                                    <h5>{{ props.option.counterparty.name }}</h5>
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="afterList">
                                            <div class="col-xs-12">
                                                <router-link :to="{name: 'markrtplacecontractstep1'}"
                                                             class="btn btn-block btn-lg btn-outline-success">
                                                    <i class="fa fa-plus-circle"></i>&nbsp;Add Contract
                                                </router-link>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <div class="invalid-feedback" v-if="submitted && errors.has('partner')">{{
                                        errors.first('partner') }}
                                    </div>
                                </div>
                                <div class="col-sm-1 text-center p-t-10 col-form-label"> OR</div>
                                <div class="col-sm-3">
                                    <input class="form-control"
                                           name="contract_number"
                                           placeholder="Add Contract Number"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="po.contract_number">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label" for="expected_delivery">Expected
                                    Delivery</label>
                                <div class="col-sm-8">
                                    <input :class="{'is-invalid': submitted && errors.has('expected_delivery')}"
                                           autocomplete="off"
                                           class="form-control"
                                           data-vv-as="expected_delivery"
                                           id="expected_delivery"
                                           name="expected_delivery"
                                           placeholder="mm/dd/yyyy"
                                           style="height: 42px;"
                                           type="text"
                                           v-model="po.expected_delivery"
                                           v-validate="'required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('expected_delivery')">{{
                                        errors.first('expected_delivery') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row" v-if="po.rows.length === 0">
                                <label class="col-md-2 text-right control-label col-form-label">Commodity</label>
                                <div class="col-md-4 mt-2">
                                    <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                                       href="javascript:void(0)" v-if="po.rows.length === 0"><b>Click here to
                                        add commodity</b></a>
                                </div>
                            </div>
                            <div class="form-group row" v-for="(row, index) in po.rows">
                                <label :for="'commodity_id'+index"
                                       class="col-md-2 text-right control-label col-form-label">Commodity</label>
                                <div class="col-md-4">
                                    <p class="form-control" style="height: 42px;">{{row.commodity.name}} <span
                                            v-if="row.commodity.code">({{row.commodity.code}})</span> -
                                        {{row.commodity.variety}}</p>
                                </div>
                                <div class="col-sm-2 input-group">
                                    <input :class="{'is-invalid': submitted && errors.has('discount')}"
                                           :value="row.commodity? row.commodity.unit_symbol : ''" class="form-control"
                                           disabled
                                           style="height: 42px">
                                    <input :class="{'is-invalid': submitted && errors.has('quantity'+index)}"
                                           :id="'quantity'+index"
                                           :name="'quantity'+index"
                                           class="form-control"
                                           data-vv-as="quantity"
                                           placeholder="Quantity"
                                           step="any"
                                           style="height: 42px; width: calc(100% - 60px)"
                                           type="number"
                                           v-model="row.quantity"
                                           v-validate="'numeric|min_value:1|required'">
                                    <div class="invalid-feedback" v-if="submitted && errors.has('quantity'+index)">{{
                                        errors.first('quantity'+index) }}
                                    </div>
                                </div>
                                <div class="col-sm-2 p-r-0">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                                               :value="currency" class="form-control"
                                               disabled style="height: 42px">
                                        <input :class="{'is-invalid': submitted && errors.has('rate'+index)}"
                                               :id="'rate'+index"
                                               :name="'rate'+index"
                                               class="form-control"
                                               data-vv-as="rate"
                                               min="1"
                                               placeholder="Rate"
                                               step="any"
                                               style="height: 42px; width: calc(100% - 80px)"
                                               type="number"
                                               v-model="row.rate"
                                               v-validate="'required'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('rate'+index)">{{ errors.first('rate'+index) }}
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div class="form-group button-group">
                                        <button class="btn btn-success" data-target="#searchAndSelectCommodityModal"
                                                data-toggle="modal" style="height: 40px"
                                                type="button" v-if="po.rows.length === 1 || index === po.rows.length-1">
                                            <i
                                                    class="fa fa-plus"></i></button>
                                        <button @click="removeRow(index)" class="btn btn-danger" style="height: 42px;"
                                                type="button"><i
                                                class="fa fa-minus"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label"
                                       for="audit">Discount</label>
                                <div class="col-sm-8">
                                    <div class="input-group">
                                        <input :class="{'is-invalid': submitted && errors.has('discount')}"
                                               :value="currency" class="form-control" disabled
                                               style="height: 42px">
                                        <input :class="{'is-invalid': submitted && errors.has('discount')}"
                                               class="form-control"
                                               data-vv-as="discount"
                                               id="discount"
                                               name="discount"
                                               placeholder="Discount"
                                               style="height: 42px; width: calc(100% - 50px)"
                                               type="number"
                                               v-model="po.discount"
                                               v-validate="'min_value:0'">
                                    </div>
                                    <div class="invalid-feedback" style="display: block"
                                         v-if="submitted && errors.has('discount')">{{ errors.first('discount') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-2 text-right control-label col-form-label"
                                       for="comments">Comments</label>
                                <div class="col-sm-9">
                                    <textarea class="form-control"
                                              id="comments"
                                              name="comments"
                                              placeholder="Comments"
                                              rows="4"
                                              v-model="po.notes"/>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="form-group m-b-0 text-right">
                                <div class="button-group">
                                    <button class="btn waves-effect waves-light btn-success" type="submit">Save</button>
                                    <button @click="reset()" class="btn waves-effect waves-light btn-secondary"
                                            type="button">Reset
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <search-select-commodity :checked-commodity-ids="commodityIds"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Multiselect from 'vue-multiselect';
    import SearchSelectCommodity from "../../common/SearchSelectCommodity";

    export default {
        name: "PurchaseOrder",
        components: {SearchSelectCommodity, Multiselect},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                partner_type: null,
                isLoading: false,
                submitted: false,
                commodityIds: [],
                suppliers: [],
                members: [],
                contracts: [],
                contract: null,
                audits: [],
                currency: null,
                po: {
                    supplier: null,
                    member: null,
                    contract_number: null,
                    contract_id: null,
                    expected_delivery: null,
                    discount: null,
                    notes: null,
                    supplier_address: {
                        email: null,
                        phone: null,
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        zip: null,
                        country: null
                    },
                    rows: []
                },
                audit: null
            };
        },
        mounted() {
            jQuery('#expected_delivery').datepicker({
                constrainInput: true,
                autoclose: true,
                todayHighlight: true
            }).on('change', (event) => {
                this.po.expected_delivery = event.target.value;
            });
            this.currency = this.currentOrg.currency_symbol;
            this.po.currency_id = this.currentOrg.currency_id;
        },
        methods: {
            addRow() {
                this.po.rows.push({
                    commodity: null,
                    quantity: null,
                    rate: null
                });
            },
            removeRow(index) {
                this.po.rows.splice(index, 1);
                this.commodityIds = this.po.rows.map(row => row.commodity.id);
            },
            async searchSuppliers(searchText) {
                let reply = await this.$http
                    .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });

                this.suppliers = reply.data;
            },
            async searchMembers(searchText) {
                let {data} = await this.$identity.get(`/identity/controller/dids?page=0&per_page=1000`);
                this.members = data.dids;
            },
            async searchContracts(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/contracts", {
                        params: {
                            number: searchText
                        }
                    });
                    this.contracts = reply.data.contracts;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        if (valid) {
                            this.save();
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            async save() {
                try {
                    this.po.contract_number = this.contract ? this.contract.contract_number : this.po.contract_number;
                    this.po.contract = this.contract ? this.contract.id : null;
                    await this.$http.put('/marketplaces/' + this.currentOrg.marketplace_id + '/purchases', this.po);
                    await this.$router.push({
                        name: "purchases",
                        params: {marketplaceid: this.currentOrg.marketplace_id}
                    });
                    this.$toastr('success', 'Purchase order added successfully.', 'Purchase Added');
                } catch (e) {
                    if (e.response.data.status === 404) {
                        this.$toastr('error', 'Commodity rate is not set, edit commodity and set rate', 'Failed');
                        await this.$router.push({
                            name: "commodities",
                            params: {marketplaceid: this.currentOrg.marketplace_id}
                        });
                    }
                }
            },
            reset() {
                this.submitted = false;
                this.po = {
                    supplier: null,
                    expected_delivery: null,
                    rows: [
                        {
                            commodity: null,
                            quantity: null,
                            rate: null
                        }
                    ]
                };
            },
            setContract() {
                this.po.contract_number = this.contract.contract_number;
            },
            setAddress(supplier) {
                if (supplier) {
                    this.po.supplier_address.email = supplier.biz_email;
                    this.po.supplier_address.phone = supplier.biz_phone;
                    this.po.supplier_address.line1 = supplier.line1;
                    this.po.supplier_address.line2 = supplier.line2;
                    this.po.supplier_address.city = supplier.city;
                    this.po.supplier_address.state = supplier.state;
                    this.po.supplier_address.zip = supplier.postal_code;
                    this.po.supplier_address.country = supplier.country;
                }
            },
            setCommodity(e) {
                let commodities = e;
                commodities.forEach(c=> {
                    let found = this.po.rows.find(row=> row.commodity.commodity_id === c.id);
                    if(!found){
                        this.po.rows.push({
                            commodity: {
                                commodity_id: c.id,
                                commodity_name: c.name,
                                unit_id: c.unit ? c.unit.id : null,
                                unit_name: c.unit ? c.unit.name : null,
                                unit_symbol: c.unit ? c.unit.symbol : null,
                                ...c
                            },
                            rate: c.rate.amount,
                            quantity: null
                        })
                    }
                })
                this.commodityIds = commodities.map(c=> c.id);

            }
        }
    }
</script>

<style scoped>
</style>
